import React from "react";
import { Box } from "@chakra-ui/react";
import { micromark } from 'micromark';
import { gfm, gfmHtml } from "micromark-extension-gfm";

const convert = src => src ? micromark(src, { extensions: [gfm()], htmlExtensions: [gfmHtml()]}) : '';

const MarkdownParser = ({src, ...props}) => (<Box {...props} dangerouslySetInnerHTML={{__html: convert(src)}} />);

export default MarkdownParser;